var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{staticClass:"tooltip",attrs:{"top":"","max-width":"400"},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('div',_vm._g({staticClass:"tooltip__text",class:_vm.classes,style:({width: _vm.width, height: _vm.height})},on),[_vm._v(_vm._s(_vm.text))])]}}])},[_c('span',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }